import { colors } from '@kiips/ui';
import type { TripCategory } from '@my-fullstack-app/itinerary-types';

const PALETTE = colors.polaroidRainbow;

/** Hash-into-palette for category swatches. Participants used to
 *  share this palette but switched to avatar + initials-gradient
 *  identity (ADR-0057 amendment); categories keep the fixed palette
 *  because they're a low-cardinality enum, not a per-person tile. */
function hashId(id: string): number {
  let h = 0;
  for (let i = 0; i < id.length; i += 1) {
    h = (h * 31 + id.charCodeAt(i)) | 0;
  }
  return Math.abs(h);
}

export function getCategoryColor(category: Pick<TripCategory, 'id' | 'colorIndex'>): string {
  const palette = PALETTE as readonly string[];
  if (
    category.colorIndex !== undefined &&
    category.colorIndex >= 0 &&
    category.colorIndex < palette.length
  ) {
    return palette[category.colorIndex]!;
  }
  return palette[hashId(category.id) % palette.length]!;
}

export const CATEGORY_PALETTE = PALETTE;
